export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxJlkc5ijTjQJElti5.8eab3c07.woff2";